import React, { useState, useEffect, useContext, useCallback } from 'react';
import "./PageDesign/Styles/NavBar.css";
import { useNavigate } from 'react-router-dom';
import { Packs } from './PageDesign/Components/Context/PacksContext';
import { UserInfo } from "./PageDesign/Components/Context/UserInfoContext";
import { MedicalContext } from './PageDesign/Components/Context/MedicalContext';
import CryptoJS from "crypto-js";
import { jwtDecode}  from 'jwt-decode';
import Audionauts from "./PageDesign/Photos/audionautas_logo_T.jpeg";

function NavBar() {
  const Navigate = useNavigate();

  const [OrderChange, setOrderChange] = useState(true);

  const {
    BasketPacks, Purchased, SetPurchased, SetAdded
  } = useContext(Packs);

  const { setLoggedIn, LoggedIn, LoggedOut, setLoggedOut, setSessionExpired
  } = useContext(UserInfo);

  const {
    RelatedExams
  } = useContext(MedicalContext);

  let plusOne = RelatedExams && RelatedExams.length !== 0 ? 1 : 0
  
  const Company = window.location.hostname.split('.')[0] === "audionautas" ? "Audionautas" : false

  const Token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
  const decodedToken = Token ? jwtDecode(CryptoJS.AES.decrypt(Token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)) : null;

  const opening = decodedToken && decodedToken.health_report === false && window.localStorage.getItem("HabitsCalculated") ? JSON.parse(window.localStorage.getItem("HabitsCalculated")) : decodedToken ? decodedToken.health_report : false
  const allowed = decodedToken && decodedToken.first_survey === false && window.localStorage.getItem("OpenAccess") ? JSON.parse(window.localStorage.getItem("OpenAccess")) : decodedToken ? decodedToken.first_survey : false

  const CurrentBasket = BasketPacks ? BasketPacks.length + plusOne : 0;
  //const [LowerBlock, setLowerBlock] = useState(window.innerWidth <= 950 ? true : false);
  const [BurgerMenu, setBurgerMenu] = useState(false);
  const [TotalInCart, setTotalInCart] = useState((window.localStorage.getItem("BasketPacks") && JSON.parse(window.localStorage.getItem("BasketPacks")).length !== 0 ? JSON.parse(window.localStorage.getItem("BasketPacks")).length : 0) + (RelatedExams && RelatedExams.length !== 0 ? 1 : 0));
  const [Notify, setNotify] = useState(TotalInCart !== 0 ? true : false);
  const [BurgerSpecific, setBurgerSpecific] = useState(window.innerWidth <= 950 ? true : false);

  useEffect(() => {
    if(BasketPacks && BasketPacks.length + plusOne !== CurrentBasket && OrderChange && Purchased && !document.URL.includes("orden-medica")) {
      SetPurchased(false)
      setOrderChange(false)
      SetAdded(false)
    }
  },[BasketPacks,CurrentBasket,OrderChange,Purchased,SetPurchased,plusOne,SetAdded])

  useEffect(() => {
    const faceArray = ["https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"]
    //preloading image
    faceArray.forEach((face) => {
      const img = new Image();
      img.src = face;
    });
  }, []);

  useEffect(() => {
    if(LoggedIn) {
      if (sessionStorage.getItem('token')) {
        let token = sessionStorage.getItem('token');
        if (isTokenExpired(token)) {
          sessionStorage.removeItem('token');
          setSessionExpired(true)
          setLoggedIn(false)
          setLoggedOut(true)
        } 
      } else {
        setLoggedOut(true)
      }
    }
    
    if(!opening && document.URL.includes("informe-de-salud")) {
      Navigate('/perfil-de-usuario')
    }

    if(!allowed && (document.URL.includes("informe-de-salud") || document.URL.includes("packs-de-examenes")  || document.URL.includes("recomendador-de-examenes") || document.URL.includes("calculadora-de-salud"))) {
      Navigate('/perfil-de-usuario')
    }

    if(LoggedIn && !LoggedOut && window.location.pathname === "/") {
      Navigate('/perfil-de-usuario')
    }

    if(LoggedOut) {
      Navigate('/');
    }

  },[LoggedIn,setLoggedIn,LoggedOut,setLoggedOut,setSessionExpired,Navigate,BasketPacks,allowed,opening,Notify,RelatedExams,TotalInCart]);

  const isTokenExpired = (token) => {
    if (!token) return true;
    try {
      let tokenDecoded = jwtDecode(CryptoJS.AES.decrypt(token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8))
      const currentTime = Date.now() / 1000;
      //console.log(decodedToken)
      return tokenDecoded.exp < currentTime;
    } catch (error) {
      console.error('Error decoding token:', error);
      return true;
    }
  };

  const hideUpperBar = useCallback(() => {
    let currentScrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (!currentScrollPos) {
      document.getElementById("navbar").style.top = "0";
    } else {
      document.getElementById("navbar").style.top = "-30px";
    }
  },[])

  function ToggleProfileMenu() {
    let x = document.getElementById("ProfileMenu")
    if(x.className.includes("NavbarFullInnerRightSideProfileButtonMenuHidden")) {
      x.className = x.className.replace(" NavbarFullInnerRightSideProfileButtonMenuHidden","")
    } else {
      x.className += " NavbarFullInnerRightSideProfileButtonMenuHidden"
    }
  }

  function ToggleBurgerMenu() {
    let x = document.getElementById("NavbarBurgerIcon")
    x.classList.toggle("change");
    if(BurgerMenu) {
      setBurgerMenu(false)
    } else {
      setBurgerMenu(true)
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", hideUpperBar);
    return () => window.removeEventListener("scroll", hideUpperBar);
  }, [hideUpperBar]);

  const HandleLowerBlock = useCallback(() => {
    if(window.innerWidth <= 950 && !BurgerSpecific) {
      setBurgerSpecific(true)
    } 
    if(window.innerWidth > 950 && BurgerSpecific) {
      setBurgerSpecific(false)
      setBurgerMenu(false)
    }
  }, [BurgerSpecific])

  useEffect(() => {
    window.addEventListener("resize", HandleLowerBlock);
    return () => window.removeEventListener("resize", HandleLowerBlock);
  }, [HandleLowerBlock]);

  useEffect(() => {
    let total = (window.localStorage.getItem("BasketPacks") && JSON.parse(window.localStorage.getItem("BasketPacks")).length !== 0 ? JSON.parse(window.localStorage.getItem("BasketPacks")).length : 0) + (window.localStorage.getItem("RelatedExams") && JSON.parse(window.localStorage.getItem("RelatedExams")).length !== 0 ? 1 : 0)
    setTotalInCart(total)
    if(total === 0) setNotify(false)
  }, [TotalInCart]);

  return (
    <div className='NavbarFull' id="navbar">
      <div className='NavbarPurpleUpBar'>
      <div className='NavbarPurpleUpBarInner'>
          <div className='NavbarPurpleUpBarInnerButton'><a href='https://empresas.ymc.cl' target="_blank" rel="noreferrer" style={{textDecoration:"none",color:"white"}}>Empresas</a></div>
          <div className='NavbarPurpleUpBarInnerButton'><a href='https://yomecontrolo.cl' target="_blank" rel="noreferrer" style={{textDecoration:"none",color:"white"}}>Personas</a></div>
          <div className='NavbarPurpleUpBarInnerSocial'>
            <a href='https://www.instagram.com/yomecontrolo/' target="_blank" rel="noreferrer" className="SocialIcon">
              <img src="https://static.yomecontrolo.cl/public/icons/social-instagram.png" alt="Instagram Icon" height={25} />
            </a>
            <a href='https://cl.linkedin.com/company/yomecontrolo' target="_blank" rel="noreferrer" className="SocialIcon">
              <img src="https://static.yomecontrolo.cl/public/icons/social-linkedin.png" alt="LinkedIn Icon" height={22} />
            </a>
          </div>
        </div>
      </div>
      <div className="NavbarFullBackGradient">
      <div className={BurgerMenu ? "NavbarFullInner NavbarFullInnerBurgerOpen" : "NavbarFullInner"}>
        <div className="NavbarFullInnerLeftSide">
            {Company || (decodedToken && decodedToken.company) ?
            <img src={Audionauts} className="NavbarFullInnerLeftSideLogoCompany" alt="logo" />
            :
            <img src="https://static.yomecontrolo.cl/public/icons/YMC_Logo_WText.png" className="NavbarFullInnerLeftSideLogoYMC" alt="logo" />
  }
        </div>

        {decodedToken ?
        <>
        {!BurgerSpecific ?
        <div className="NavbarFullInnerMiddle">
          <div className="NavbarFullInnerMiddleButton" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/perfil-de-usuario")}}>Inicio</div>
          <div className="NavbarFullInnerMiddleButton" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/perfil-de-usuario/calculadora-de-salud")}}>Mide tus riesgos</div>
          <div className="NavbarFullInnerMiddleButton" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/perfil-de-usuario/informe-de-salud")}}>Informe de Salud</div>
          <div className="NavbarFullInnerMiddleButton" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/plan-de-intervencion")}}>Recomendaciones</div>
          {/*}
          <div className="NavbarFullInnerMiddleButton" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/packs-de-examenes")}}>Órdenes de exámenes</div>
          <div className="NavbarFullInnerMiddleButton" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/perfil-de-usuario/antecedentes-medicos")}}>Perfil de Salud</div>
          */}
        </div>
        : null }

        <div className="NavbarFullInnerRightSide">
          <div className='NavbarFullInnerLeftSideInitial' onClick={() => ToggleProfileMenu()}>{decodedToken.name[0]}
            <div className="NavbarFullInnerRightSideProfileButtonMenu NavbarFullInnerRightSideProfileButtonMenuHidden" id="ProfileMenu">
              {/*<div className="NavbarFullInnerRightSideProfileButtonMenuItem" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/perfil-de-usuario")}}>Inicio</div>
              <div className="NavbarFullInnerRightSideProfileButtonMenuItemDivider"></div>*/}
              <div className="NavbarFullInnerRightSideProfileButtonMenuItem" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; sessionStorage.removeItem('token'); setLoggedIn(false); setLoggedOut(true);}}>Cerrar Sesión</div>
            </div>
          </div>
          <div className='NavbarFullInnerLeftSideOrderButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/orden-medica")}}>
            <img alt="" className='NavbarFullInnerLeftSideOrderButtonIcon' src="https://static.yomecontrolo.cl/public/icons/WhiteExamIcon.png" />
            {Notify ?
              <div className='NavbarFullInnerLeftSideOrderButtonNotification'>{TotalInCart}</div>
            : null}
          </div>
          {BurgerSpecific ?
          <div className="NavbarFullInnerMiddleButtonBurger" onClick={() => ToggleBurgerMenu()}>
            <div className="NavbarFullInnerRightSideBurgerIcon" id="NavbarBurgerIcon">
              <div className="NavbarBurgerIconBar3"></div>
              <div className="NavbarBurgerIconBar1"></div>
              <div className="NavbarBurgerIconBar2"></div>
            </div>
          </div>
          : null}
        </div>
        </>
        : 
        null
}
        </div>
        {BurgerMenu ? 
        <div className="NavbarFullInnerLowerBlock">
          <div className="NavbarFullInnerLowerBlockButton" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/perfil-de-usuario")}}>Inicio</div>
          <div className="NavbarFullInnerLowerBlockButton" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/perfil-de-usuario/calculadora-de-salud")}}>Mide tus riesgos</div>
          <div className="NavbarFullInnerLowerBlockButton" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/perfil-de-usuario/informe-de-salud")}}>Informe de Salud</div>
          <div className="NavbarFullInnerLowerBlockButton" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/plan-de-intervencion")}}>Recomendaciones</div>
          {/*
          <div className="NavbarFullInnerLowerBlockButton" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/packs-de-examenes")}}>Órdenes de exámenes</div>
          <div className="NavbarFullInnerLowerBlockButton" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/perfil-de-usuario/antecedentes-medicos")}}>Perfil de Salud</div>
          */}
        </div>
        : null}
      </div>
    </div>
  );
}

export default NavBar;